import { LensHit } from "Backend";
import { DocumentIntake, FormField } from "generated/graphql";
import { createContext, Dispatch, SetStateAction } from "react";
import { UseFormCard } from "routes/lenses/lens/case/useFormCard";

interface IHitTableContext {
  lensId: number;
  caseId: number;
  intake: DocumentIntake | undefined;
  formField: FormField;
  formCardMap: Map<number, UseFormCard>;
  setFormCardMap: (map: Map<number, UseFormCard>) => void;
  hitInEdit: number | undefined;
  setHitInEdit: (hitId: number | undefined) => void;
  hits: LensHit[];
  setHits: Dispatch<SetStateAction<LensHit[]>>;
  hitsFullCount: number;
  setHitsFullCount: Dispatch<SetStateAction<number>>;
  checkedHits: LensHit[];
  setCheckedHits: Dispatch<SetStateAction<LensHit[]>>;
}

export const HitTableContext = createContext<IHitTableContext>(null!);
